(() => {
  const layer = document.querySelector('[data-reaze-route-transition]');
  const video = layer?.querySelector('[data-reaze-transition-video]');
  if (!layer || !video || layer.dataset.initialized) return;
  layer.dataset.initialized = 'true';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canAnimate = () => !reducedMotion.matches && !navigator.connection?.saveData;
  const prepare = () => {
    if (!canAnimate() || video.getAttribute('src')) return;
    video.muted = true;
    video.src = video.dataset.src;
    video.load();
  };
  const ctaSelector = '.reaze-hero__form button,.reaze-signup__fields button,.wl-submit-btn,#wlOpenBtn,.rsv-hero__cta';
  document.addEventListener('pointerover', (event) => {
    if (event.target.closest(ctaSelector)) prepare();
  }, { passive: true });
  document.addEventListener('focusin', (event) => {
    if (event.target.closest('.reaze-hero__form,.reaze-signup__form,.wl-custom-form')) prepare();
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== '/pages/reservation' || location.pathname === '/pages/reservation') return;
    url.searchParams.set('reaze_entry', 'reservation');
    link.href = url.href;
  });
  const url = new URL(location.href);
  const entry = url.searchParams.get('reaze_entry');
  if (url.pathname !== '/pages/reservation' || !['waitlist', 'reservation'].includes(entry)) return;
  url.searchParams.delete('reaze_entry');
  history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
  const arrival = window.reazeBrandArrival;
  if (!canAnimate() || !arrival?.active) {
    document.documentElement.classList.remove('reaze-route-pending');
    if (arrival) clearTimeout(arrival.timeout);
    return;
  }
  clearTimeout(arrival.timeout);
  let dismissed = false;
  let timeout;
  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    clearTimeout(timeout);
    arrival.active = false;
    document.documentElement.classList.remove('reaze-route-pending');
    layer.classList.remove('is-visible');
    window.setTimeout(() => {
      layer.hidden = true;
      video.pause();
    }, 180);
  };
  prepare();
  layer.hidden = false;
  layer.classList.add('is-visible');
  video.addEventListener('playing', () => layer.classList.add('is-playing'), { once: true });
  video.addEventListener('ended', dismiss, { once: true });
  video.addEventListener('error', dismiss, { once: true });
  timeout = window.setTimeout(dismiss, 1400);
  video.play().catch(dismiss);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dismiss();
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) dismiss();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) dismiss();
  });
  window.addEventListener('pagehide', dismiss, { once: true });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.documentElement.classList.remove('reaze-route-pending');
      layer.hidden = true;
      video.pause();
    }
  });
})();
